import { FORGOTTEN_FAVOURITES_PRODUCTS_ACTIONS } from 'redux/modules/favourites/actions/types';
import favouritesFilters from 'redux/modules/favourites/actions/define-favourites-filters';
import products from 'api/definitions/products';
import { getProducts } from 'redux/modules/products/actions/get-products';

export const fetchForgottenFavourites =
  ({ size = 96, start = 0 } = {}) =>
  (dispatch, getState) => {
    const state = getState();
    const fetchForgottenFavouriteProducts = getProducts(FORGOTTEN_FAVOURITES_PRODUCTS_ACTIONS);

    return dispatch(
      fetchForgottenFavouriteProducts({
        ...favouritesFilters({ start, state }),
        excludeTrolleyLines: true,
        sortBy: products.SORT_WEIGHTED_FAVOURITES,
        excludeLinesWithConflicts: true,
        size,
        showRecommendations: true,
      }),
    );
  };
